import { PriceSuggestionType } from '@retail/products/types';
import { CalculusConditionDTO } from '../../dtos';
import { dateFromString } from '@retail/utils';
import { ConditionBaseProps, ItemConditionBase } from '../ConditionBase';
import { SupplierBase } from '@retail/suppliers/types';

export interface MarkupOrPriceSuggestionConditionProps
  extends ConditionBaseProps<MarkupOrPriceSuggestionCondition> {
  priceSuggestionType?: PriceSuggestionType;
  coverageDegree?: number;
}

export class MarkupOrPriceSuggestionCondition extends ItemConditionBase<MarkupOrPriceSuggestionCondition> {
  priceSuggestionType?: PriceSuggestionType;
  coverageDegree?: number;

  constructor({
    priceSuggestionType,
    coverageDegree,
    ...superProps
  }: MarkupOrPriceSuggestionConditionProps) {
    if (!priceSuggestionType && !coverageDegree && coverageDegree !== 0) {
      throw new Error(
        `Condition id: ${superProps.id} is missing ${
          superProps.type === 'MARKUP' ? 'coverageDegree' : 'priceSuggestion'
        }`
      );
    }
    super(superProps);
    this.priceSuggestionType = priceSuggestionType;
    this.coverageDegree = coverageDegree;
  }

  static fromDto = (dto: CalculusConditionDTO): MarkupOrPriceSuggestionCondition =>
    new MarkupOrPriceSuggestionCondition({
      id: dto.id,
      assortmentId: dto.assortmentId,
      assortmentName: dto.assortmentName,
      inDraft: dto.inDraft,
      type: dto.type,
      supplier: dto.supplier ? SupplierBase.fromDto(dto.supplier) : undefined,
      bindingType: dto.bindingType,
      bindingTarget: dto.bindingTarget,
      bindingTargetName: dto.bindingTargetName,
      bindingTargetId: dto.bindingTargetId,
      bindingTargetItem: dto.bindingTargetItem,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
      priceSuggestionType: dto.priceSuggestionType,
      coverageDegree: dto.coverageDegree,
    });
}
